import moment from 'moment'
export function medicalInfo (data) {
  const medicalInfo = data.map(function(element) {
    return {
      'Recorded on': moment(element.recorded_on).format('DD-MM-YYYY'),
      'Height': element.height,
      'Weight': element.weight,
      'Test type': element.test_type,
      'Test result': element.test_result,
    }
  })

  return medicalInfo
}
